/* Batch 32 · B32-1 — the figures layer said in one full sentence with its reason, as plain text under the page title (not a
   button, no pointer): grey icon for unadjusted figures from client data, indigo for figures including audit adjustments.
   Replaces the LayerBadge pill (Batch 13 · AE9) on the 9 screens that show ledger figures. */
import React from "react";
import { Layers } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { LAYER_OF_SCREEN } from "@/lib/i18n/1130_b32_layer";

export default function LayerLine({ screen, className = "" }) {
  const { t } = useI18n();
  const adjusted = LAYER_OF_SCREEN[screen] === "adjusted";
  return (
    <p className={`mt-1 flex items-start gap-1.5 text-xs text-muted-foreground ${className}`}
       data-testid="layer-line" data-layer={adjusted ? "adjusted" : "client"} data-screen={screen}>
      <Layers aria-hidden="true" className={`mt-0.5 h-3.5 w-3.5 shrink-0 ${adjusted ? "text-indigo-600 dark:text-indigo-400" : "text-slate-400"}`} />
      <span>{t(`layerLine.${screen}`)}</span>
    </p>
  );
}
